import React from "react";
import css from './SocialMediaFields.module.css'

const SocialMediaFields = props => {
    const { icon, propsForCustomFields, field, isUrl = false } = props
    const fieldDetails = propsForCustomFields?.find(({ key }) => key == field) || {}
    return <div className={css.fieldWrapper}>
        <img src={icon} className={css.icon} />
        {isUrl ? <a href={fieldDetails.text} target="_blank">{fieldDetails.text}</a> : <span>{fieldDetails.text}</span>}
    </div>
}

export default SocialMediaFields